import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RouterModule, Routes } from '@angular/router';
import { Angulartics2GoogleAnalytics } from 'angulartics2';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	constructor(translate:TranslateService, angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {
		translate.addLangs(["en","es"]);
		translate.setDefaultLang('es');

		let browserLang = translate.getBrowserLang();
		translate.use(browserLang.match(/en|es/) ? browserLang : 'es');
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts